(function () {
  let storedRefresh = null;
  let guardedUi = null;
  let affirmValue = window.affirm;
  let pollTimer = null;
  let fastPollIntervalMs = 20;
  let slowPollIntervalMs = 500;

  function noopRefresh() {}

  function attachAffirmRefreshGuard() {
    if (!window.affirm || !window.affirm.ui) {
      guardedUi = null;
      return false;
    }

    let ui = window.affirm.ui;

    if (guardedUi === ui && typeof ui.refresh === 'function') {
      storedRefresh = ui.refresh;
      return true;
    }

    if (guardedUi !== ui) {
      guardedUi = ui;
      storedRefresh = null;
    }

    if (typeof ui.refresh === 'function') {
      storedRefresh = ui.refresh;
      return true;
    }

    try {
      Object.defineProperty(ui, 'refresh', {
        configurable: true,
        enumerable: true,
        get: function () {
          if (typeof storedRefresh === 'function') {
            return storedRefresh;
          }

          return noopRefresh;
        },
        set: function (value) {
          storedRefresh = value;
        },
      });
    } catch (error) {
      return false;
    }

    return typeof storedRefresh === 'function';
  }

  function hookWindowAffirm() {
    try {
      Object.defineProperty(window, 'affirm', {
        configurable: true,
        get: function () {
          return affirmValue;
        },
        set: function (value) {
          affirmValue = value;
          guardedUi = null;
          attachAffirmRefreshGuard();
        },
      });
    } catch (error) {
      return;
    }

    affirmValue = window.affirm;
  }

  function startAffirmRefreshGuard() {
    if (pollTimer) {
      return;
    }

    let fastPollCount = 0;
    let maxFastPollAttempts = 300;

    pollTimer = window.setInterval(function () {
      attachAffirmRefreshGuard();
      fastPollCount += 1;

      if (fastPollCount >= maxFastPollAttempts) {
        window.clearInterval(pollTimer);
        pollTimer = window.setInterval(attachAffirmRefreshGuard, slowPollIntervalMs);
      }
    }, fastPollIntervalMs);
  }

  hookWindowAffirm();
  attachAffirmRefreshGuard();
  startAffirmRefreshGuard();

  window.theme = window.theme || {};
  window.theme.affirmUiGuard = {
    attachAffirmRefreshGuard: attachAffirmRefreshGuard,
    startAffirmRefreshGuard: startAffirmRefreshGuard,
  };
})();
